/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_Subscribe_QueryVariables = {
    serviceID: string;
};
export type App_Subscribe_QueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"Subscribe_viewer">;
    } | null;
    readonly service: {
        readonly " $fragmentRefs": FragmentRefs<"Subscribe_service">;
    } | null;
    readonly subscriptionFee: number;
};
export type App_Subscribe_Query = {
    readonly response: App_Subscribe_QueryResponse;
    readonly variables: App_Subscribe_QueryVariables;
};



/*
query App_Subscribe_Query(
  $serviceID: ID!
) {
  viewer {
    ...Subscribe_viewer
    id
  }
  service: node(id: $serviceID) {
    __typename
    ...Subscribe_service
    id
  }
  subscriptionFee
}

fragment CostCalculator_service on Service {
  charges(first: 100) {
    edges {
      node {
        id
        chargeType
        name
        description
        price {
          value
          currency
        }
        metricName
        salesTax {
          value
          currency
        }
      }
    }
  }
}

fragment Subscribe_service on Service {
  id
  name
  description
  imageURL
  supportedCurrencies
  charges(first: 100) {
    edges {
      node {
        id
        chargeType
        name
        description
        price {
          value
          currency
        }
        metricName
        salesTax {
          value
          currency
        }
      }
    }
  }
  ...CostCalculator_service
}

fragment Subscribe_viewer on User {
  id
  userAccounts {
    id
    name
    subscriber {
      defaultMethod {
        last4
      }
      currency
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "serviceID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionFee",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "App_Subscribe_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Subscribe_viewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "service",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Subscribe_service"
          }
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "App_Subscribe_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "userAccounts",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscriber",
                "kind": "LinkedField",
                "name": "subscriber",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentMethod",
                    "kind": "LinkedField",
                    "name": "defaultMethod",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "last4",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "service",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageURL",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportedCurrencies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                  }
                ],
                "concreteType": "ChargeConnection",
                "kind": "LinkedField",
                "name": "charges",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChargeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Charge",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "chargeType",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Amount",
                            "kind": "LinkedField",
                            "name": "price",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "metricName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Amount",
                            "kind": "LinkedField",
                            "name": "salesTax",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "charges(first:100)"
              }
            ],
            "type": "Service",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "cacheID": "402e85e1a7af50299c2f84ee25a55e89",
    "id": null,
    "metadata": {},
    "name": "App_Subscribe_Query",
    "operationKind": "query",
    "text": "query App_Subscribe_Query(\n  $serviceID: ID!\n) {\n  viewer {\n    ...Subscribe_viewer\n    id\n  }\n  service: node(id: $serviceID) {\n    __typename\n    ...Subscribe_service\n    id\n  }\n  subscriptionFee\n}\n\nfragment CostCalculator_service on Service {\n  charges(first: 100) {\n    edges {\n      node {\n        id\n        chargeType\n        name\n        description\n        price {\n          value\n          currency\n        }\n        metricName\n        salesTax {\n          value\n          currency\n        }\n      }\n    }\n  }\n}\n\nfragment Subscribe_service on Service {\n  id\n  name\n  description\n  imageURL\n  supportedCurrencies\n  charges(first: 100) {\n    edges {\n      node {\n        id\n        chargeType\n        name\n        description\n        price {\n          value\n          currency\n        }\n        metricName\n        salesTax {\n          value\n          currency\n        }\n      }\n    }\n  }\n  ...CostCalculator_service\n}\n\nfragment Subscribe_viewer on User {\n  id\n  userAccounts {\n    id\n    name\n    subscriber {\n      defaultMethod {\n        last4\n      }\n      currency\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'fdf71304cdc56a996c8bfda26f0bebab';
export default node;
